import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Fan = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9991 11.9991C8.99915 11.9991 6.49915 9.49915 6.49915 6.49915C6.49915 3.92915 8.32915 1.72915 10.7391 1.14915C11.3791 0.999145 11.9991 1.46915 11.9991 2.11915V11.9991ZM11.9991 11.9991C11.9991 8.99915 14.4991 6.49915 17.4991 6.49915C20.0691 6.49915 22.2691 8.32915 22.8491 10.7391C22.9991 11.3791 22.5291 11.9991 21.8791 11.9991H11.9991ZM11.9991 11.9991V21.8791C11.9991 22.5291 12.6191 22.9991 13.2591 22.8491C15.6691 22.2691 17.4991 20.0691 17.4991 17.4991C17.4991 14.4991 14.9991 11.9991 11.9991 11.9991ZM11.9991 11.9991C11.9991 14.9991 9.49915 17.4991 6.49915 17.4991C3.92915 17.4991 1.72915 15.6691 1.14915 13.2591C0.999145 12.6191 1.46915 11.9991 2.11915 11.9991H11.9991Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default Fan;
